<!--
 * @Author: your name
 * @Date: 2020-07-22 16:49:18
 * @LastEditTime: 2020-10-10 14:20:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\components\paper\child_paper.vue
--> 
<!-- 
			desc : 子卷
 -->
<template>
  <div class="child_paper">
    <!--  -->
    <div class="paper_name">
      <b>{{childPaper.pname}}</b>
    </div>
    <!-- 
			如果大题不为空则遍历大题
    -->
    <div v-if="childPaper.gkBigQuestions!= null ">
      <div
        class="concrete_question"
        v-for="(bigQuestion,index) in childPaper.gkBigQuestions"
        :key="index"
      >
        <bigQuestion :isShowCorrectBtn="isShowCorrectBtn" :isShowAnswerArea="isShowAnswerArea" :is-show-self-answer="isShowSelfAnswer" :big-question="bigQuestion" :self-assessment="selfAssessment" :my-answer="myAnswer" :isDisabled="isDisabled"></bigQuestion>
      </div>
    </div>
    <!-- 
			如果大题为空,则遍历其他题
    -->
    <div v-else>
      <div
        class="concrete_question"
        v-for="(question,index) in childPaper.gkQuestions"
        :key="index"
      >
        <template v-if="question.typeCode == 'M'">
          <compositeQuestion :isShowCorrectBtn="isShowCorrectBtn" :isShowAnswerArea="isShowAnswerArea" :is-show-self-answer="isShowSelfAnswer" :question="question" :isDisable="isDisable"></compositeQuestion>
        </template>
        <template v-else>
          <baseQuestion :isShowCorrectBtn="isShowCorrectBtn" :isShowAnswerArea="isShowAnswerArea" :is-show-self-answer="isShowSelfAnswer" :question="question" :isDisable="isDisable"></baseQuestion>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import compositeQuestion from "@/components/paper/question/question/composite_question";
import bigQuestion from "@/components/paper/question/question/big_question";
import baseQuestion from "@/components/paper/question/question/base_question"

export default {
  name: "childPaper",
  components: {
    compositeQuestion,
    bigQuestion,
    baseQuestion
  },
  props: {
    childPaper: Object,
    // 自评时需要传
    selfAssessment: {
      type: Boolean,
      default : false
    },
    myAnswer: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    //是否显示自答答案
    isShowSelfAnswer :{
      type: Boolean,
      default: false,
    },
    isShowAnswerArea:{
      type : Boolean,
      default: true,
    },
    isShowCorrectBtn : {
      type : Boolean,
      defalut : true
    }
  },
  mounted(){
  }
};
</script>

<style lang="stylus" scoped>
.child_paper {
  width: 1576px;
  position: relative;
  float: left;

  .paper_name {
    font-size: 32px;
    text-align: center;
    height: 85px;
    line-height: 85px;
    background-color: #ffffff;
    color: #585858;
  }

  .concrete_question {
  }
}
</style>